import useIsMobile from '@/hooks/useIsMobile';
import useSelectTemplate from './useSelectTemplate';
import SelectTemplateDesktop from './desktop';
import SelectTemplateMobile from './mobile';

function SelectTemplate() {
  const isMobile = useIsMobile(992);
  const viewModel = useSelectTemplate();

  return isMobile ? <SelectTemplateMobile viewModel={viewModel} /> : <SelectTemplateDesktop viewModel={viewModel} />;
}

export default SelectTemplate;
